exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".plan-tabs-content[data-v-83a68c22]  .el-tabs__header{margin-bottom:0}.plan-tabs-content[data-v-83a68c22]  .el-tabs__header .el-tabs__nav-wrap::after{height:1px;background-color:#eee}\n", ""]);

// exports
